<div id="home-funds">
  <div class="container px-4">
    <div class="row">
      <div class="col-12 col-lg-5 ps-3 ps-lg-4 border-linea border-radius-2 border-secondary-funds-600">
        <p class="primary-800 tabs">SEGO <span class="secondary-funds-500">Funds</span></p>
        <h1 class="primary-900">Disfruta de las<br> mejores ventajas</h1>
      </div>
      <div class="col-12 col-lg-7 gx-0 d-flex flex-column justify-content-end mt-4 mt-lg-0">
        <p class="p2-medium neutral-500 my-2">
          Invierte con SEGO Funds y <span class="p2-bold">descubre cómo ahorrar</span> con nuestras <span
            class="p2-bold">carteras, depósitos,cuenta remunerada y ahora también
            criptos</span>.
        </p>
        <div class="link-container mb-2">
          @if (isPlatformFunds) {
          <a id="home-funds-depositos" routerLink="/cuentas-remuneradas"
            class="link1-bold primary-900 d-flex align-items-center" title="Ver nuestra cuenta remunerada">
            <span class="me-1">Ver nuestra cuenta remunerada</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
          }
          @if (!isPlatformFunds) {
          <a id="home-funds-depositos" href="{{domainUrl + '/cuentas-remuneradas'}}"
            class="link1-bold primary-900 d-flex align-items-center" title="Ver nuestra cuenta remunerada"
            target="_blank">
            <span class="me-1">Ver nuestra cuenta remunerada</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
          }
        </div>
      </div>
      <div class="col-12 mt-3 mb-2 bg-primary-100 border-radius-4 p-2">
        <div class="mx-3 mx-lg-4">
          <p class="p3-regular neutral-900">Producto ofrecido por Fintup Digital S.L, sociedad del grupo SegoFinance, y
            Agente Financiero de MyInvestor Banco S.A., y Agente de Seguros de MEDVIDA Partners, con Código mediador:
            C0559B87860854.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3 mt-lg-4 fadein">
    <div id="contenedor-swiper-home-funds" class="swiper swiperHomeFunds">
      <div class="swiper-wrapper">
        @for (criptoCardData of criptoCardDataList; track criptoCardData.id) {
        <div class="swiper-slide align-items-stretch">
          @if(isPlatformFunds){
          <a routerLink="/criptomonedas">
            <app-ficha-cartera [criptoCardData]="criptoCardData"></app-ficha-cartera>
          </a>
          }@else{
          <a href="{{domainUrl + '/criptomonedas'}}">
            <app-ficha-cartera [criptoCardData]="criptoCardData"></app-ficha-cartera>
          </a>
          }
        </div>
        }
      </div>
    </div>
    <div id="pagination">
      <div class="swiper-pagination swiper-home-funds position-relative mt-4"></div>
    </div>
  </div>

  <div id="contenedor-margen" class="container">
    <div class="row mt-4 pt-lg-3">
      <div class="col-12 text-center">
        @if (isPlatformFunds) {
        <a id="home-funds-abrir-cuenta" class="btn btn-primary" title="Saber más" routerLink="/criptomonedas">
          <div class="d-flex align-items-center justify-content-center">
            <span>Saber más</span> <span class="material-symbols-outlined ms-2">chevron_right</span>
          </div>
        </a>
        }
        @if (!isPlatformFunds) {
        <a id="home-funds-abrir-cuenta" class="btn btn-primary" title="Saber más" href="{{domainUrl + '/criptomonedas'}}">
          <div class="d-flex align-items-center justify-content-center">
            <span>Saber más</span> <span class="material-symbols-outlined ms-2">chevron_right</span>
          </div>
        </a>
        }
      </div>
    </div>
  </div>
</div>